import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';

import { Helpers } from '../../core/src/helpers';
import withPageComponents from './with-page-components';
import { StoreAppAPI } from '../../core/src/storeapp-api-client';

const storeAppAPI = new StoreAppAPI();

const IntopicArticles = loadable(() => Helpers.retryFunc(() => import('../../shared/components/intopic-articles')));

const getDerivedTagsAndCategories = Helpers.memoize((seo, mdpProductList) => {
    try {
        const { products: mdpProducts } = mdpProductList || {};
        const [firstProduct] = mdpProducts || [];
        const topCategory = firstProduct?.topCategory && firstProduct?.topCategory.toLowerCase();
        if (topCategory) {
            return {
                categories: [topCategory],
                tags: (firstProduct.usageLabel || []).reduce((r, tag) => {
                    if (tag) {
                        const lcTag = tag.toLowerCase();
                        r.push(lcTag);
                        r.push(`${lcTag}-${topCategory}`);
                    }
                    return r;
                }, []),
            };
        }
        return seo || {};
    } catch (e) {
        return seo || {};
    }
});

export default withPageComponents(
    ({ templateKey, intopicArticles, mdpProductList, seo }) => {
        const [blogs, setBlogs] = useState(intopicArticles?.blogs);
        const showIntopicArticles = ['sale-v3', 'gift-guide', 'mdp'].includes(templateKey);
        const { categories, tags } = getDerivedTagsAndCategories(seo, mdpProductList);
        useEffect(() => {
            if (categories?.length === 0 && tags?.length === 0) {
                return;
            }
            if (showIntopicArticles) {
                storeAppAPI.page.getIntopicBlogs(categories, tags).then(resp => {
                    const { blogs } = resp || {};
                    setBlogs(blogs);
                });
            }
        }, [categories, tags]);

        if (!showIntopicArticles) return null;

        return <IntopicArticles blogs={blogs} />;
    },
    { components: ['intopicArticles', 'mdpProductList'], seo: true },
);
